import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogActions, DialogContent,
  TextField, Button, Grid, Typography,
  Checkbox, FormControlLabel, MenuItem,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import axios from "../../../config/axios";
import { getReturnOrders } from "redux/action/order.action";

const HOURS = [
  "07:00","08:00","09:00","10:00","11:00","12:00",
  "13:00","14:00","15:00","16:00","17:00","18:00","19:00",
];

const DEFAULTS = {
  order_id: "",
  return_date: new Date().toISOString().split("T")[0],
  return_time: "09:00",
  address: "",
  floor: "",
  city: "",
  zipcode: "",
  shipping_cost: "",
  trips_count: "1",
  partial: false,
  item_descriptions: "",
  notes: "",
};

export default function CreateManualReturnDialog({ open, onClose }) {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleChange = field => e => { const v = e.target.value; setForm(f => ({ ...f, [field]: v })); };

  const handleSubmit = async () => {
    if (!form.order_id.trim() || !form.return_date) {
      enqueueSnackbar("Order ID e data são obrigatórios.", { variant: "warning" });
      return;
    }
    setLoading(true);
    try {
      await axios.post("/admin/create-manual-return", {
        order_id: form.order_id.trim(),
        return_date: form.return_date,
        return_time: form.return_time,
        location: {
          address: form.address || null,
          floor: form.floor || null,
          city: form.city || null,
          zipcode: form.zipcode || null,
        },
        shipping_cost: parseFloat(form.shipping_cost) || 0,
        trips_count: parseInt(form.trips_count, 10) || 1,
        partial: form.partial,
        item_descriptions: form.item_descriptions || null,
        notes: form.notes || null,
      });
      enqueueSnackbar("Devolução criada com sucesso.", { variant: "success" });
      dispatch(getReturnOrders({}));
      setForm(DEFAULTS);
      onClose();
    } catch (err) {
      enqueueSnackbar(err?.response?.data?.message || "Erro ao criar devolução.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const field = (label, key, opts = {}) => (
    <Grid item xs={12} sm={opts.sm || 6}>
      <TextField
        fullWidth label={label} value={form[key]}
        onChange={handleChange(key)}
        variant="outlined" size="small"
        {...opts}
      />
    </Grid>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Nova Devolução Manual</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary" style={{ marginBottom: 16, display: "block" }}>
          Cria uma devolução para um cliente manual. O Order ID está disponível na lista de Pedidos de Recolha (coluna ID) ou no URL ao abrir o detalhe da recolha.
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 4 }}>

          {field("Order ID *", "order_id", { sm: 12, placeholder: "Ex: 6673f1a2b4c5d6e7f8a9b0c1" })}

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginTop: 8, marginBottom: 4 }}>Data e hora</Typography>
          </Grid>
          {field("Data da devolução *", "return_date", { type: "date", InputLabelProps: { shrink: true } })}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="Hora" value={form.return_time}
              onChange={handleChange("return_time")}
              variant="outlined" size="small"
            >
              {HOURS.map(h => <MenuItem key={h} value={h}>{h}</MenuItem>)}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginTop: 8, marginBottom: 4 }}>Morada de entrega</Typography>
          </Grid>
          {field("Morada", "address", { sm: 12 })}
          {field("Andar / Porta", "floor")}
          {field("Cidade", "city")}
          {field("Código Postal", "zipcode")}

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginTop: 8, marginBottom: 4 }}>Detalhes da devolução</Typography>
          </Grid>
          {field("Custo de transporte (€ c/IVA)", "shipping_cost", { type: "number" })}
          {field("Nº de viagens", "trips_count", { type: "number" })}

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.partial}
                  onChange={e => { const v = e.target.checked; setForm(f => ({ ...f, partial: v })); }}
                  color="primary"
                />
              }
              label="Devolução parcial (apenas alguns items)"
            />
          </Grid>

          {field("Items devolvidos / Códigos de barras", "item_descriptions", {
            sm: 12, multiline: true, rows: 3,
            placeholder: "Ex:\nCaixa grande — CB: KW-0041\nEspelho — CB: KW-0042\n...",
          })}
          {field("Notas adicionais", "notes", { sm: 12, multiline: true, rows: 2 })}

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? "A criar..." : "Criar Devolução"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
